import { render, staticRenderFns } from "./ContractTermsForms.vue?vue&type=template&id=11be72b4&"
import script from "./ContractTermsForms.vue?vue&type=script&lang=js&"
export * from "./ContractTermsForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports